import React from "react";
import rental_rules_bg from "../../../Assets/Images/Rental/rental_rules_bg.webp";

const RentalRules = ({ rules }) => {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-12">
      <div className=" relative bg-[#063146] rounded-lg overflow-hidden py-8">
        {/* Background image */}
        <div
          className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${rental_rules_bg})`,
          }}
        />
        {/* Dark Overlay for better text readability */}
        <div className="absolute inset-0 bg-black bg-opacity-30 z-0" />

        {/* Content */}
        <div className="relative px-4 md:px-8 lg:px-10 z-10 flex w-full flex-col lg:flex-row gap-6 md:gap-8 lg:gap-10 items-center lg:items-start">
          {/* Rules List - grow to fill remaining space */}
          <div className="flex-1 order-2 lg:order-1 space-y-4 md:space-y-3 text-justify">
            {/* Light heading description at the top of all rules */}
            <div className="mb-6">
              <p className="text-white/80 text-sm md:text-base italic font-light border-l-4 border-white/30 pl-4">
                To ensure a smooth and fair experience for all athletes, teams, and guests, 
                please review the following rental policies:
              </p>
            </div>
            
            {rules?.map((rule, index) => (
              <div key={index} className="flex items-start space-x-2">
                <div className="mt-2">
                  <div className="w-1.5 h-1.5 bg-white rounded-full" />
                </div>
                <p className="text-white text-sm md:text-base leading-relaxed font-medium tracking-wide">
                  {rule}
                </p>
              </div>
            ))}
          </div>

          {/* Title Section - shrink to fit */}
          <div className="hidden lg:flex flex-shrink-0 order-1 lg:order-2 font-heading font-bold text-white leading-tight tracking-wider lg:text-right text-center">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl">
              RENTAL
              <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300">
                RULES
              </span>
            </h2>
          </div>
          
          {/* Mobile view */}
          <div className="lg:hidden pl-4 w-full flex-shrink-0 order-1 font-heading font-bold text-white leading-tight tracking-wider">
            <h2 className="text-2xl text-left sm:text-3xl">
              RENTAL RULES
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RentalRules;






// import React from "react";
// import rental_rules_bg from "../../../Assets/Images/Rental/rental_rules_bg.webp";

// const RentalRules = ({ rules }) => {
//   return (
//     <section className="w-full px-4 md:px-8 lg:px-12 py-12">
//       <div className=" relative bg-[#063146] rounded-lg overflow-hidden py-8">
//         {/* Background image */}
//         <div
//           className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
//           style={{
//             backgroundImage: `url(${rental_rules_bg})`,
//           }}
//         />
//         {/* Dark Overlay for better text readability */}
//         <div className="absolute inset-0 bg-black bg-opacity-30 z-0" />

//         {/* Content */}
//         <div className="relative px-4 md:px-8 lg:px-10 z-10 flex w-full flex-col lg:flex-row gap-6 md:gap-8 lg:gap-10 items-center lg:items-start">
//           {/* Rules List - grow to fill remaining space */}
//           <div className="flex-1 order-2 lg:order-1 space-y-4 md:space-y-3  text-justify">
//             {rules?.map((rule, index) => (
//               <div key={index} className="flex items-start space-x-2">
//                 <div className="mt-2">
//                   <div className="w-1.5 h-1.5 bg-white rounded-full" />
//                 </div>
//                 <p className="text-white text-sm md:text-base leading-relaxed font-medium tracking-wide">
//                   {rule}
//                 </p>
//               </div>
//             ))}
//           </div>

//           {/* Title Section - shrink to fit */}
//           <div className="hidden lg:flex flex-shrink-0 order-1 lg:order-2 font-heading font-bold text-white leading-tight tracking-wider lg:text-right text-center">
//             <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl">
//               RENTAL
//               <br />
//               <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-300">
//                 RULES
//               </span>
//             </h2>
//           </div>
//           {/* Mobile view */}
//           <div className="lg:hidden pl-4 w-full flex-shrink-0 order-1 font-heading font-bold text-white leading-tight tracking-wider  ">
//             <h2 className="text-2xl text-left sm:text-3xl lg:text-4xl">
//               RENTAL RULES
//             </h2>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// export default RentalRules;
